import React from 'react';
import isNull from 'lodash/isNull';

import { ChildType } from './DeprecatedDropdownItem';

export const getCheckboxId = (children): string | undefined => {
  if (!isNull(children)) {
    return React.Children.map(children as ChildType, (child: ChildType) => {
      if (child && child.type && child.type.displayName === 'Checkbox') {
        return child.props.id;
      }
      return undefined;
    })[0];
  }
  return undefined;
};
